import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import './Blog.css'; // varsa özel stil

const apiUrl = process.env.REACT_APP_API_BASE_URL;

const Blog = () => {
  const [blogs, setBlogs] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const blogsPerPage = 9;

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await fetch(`${apiUrl}/api/blogs`);
        const data = await response.json();
        setBlogs(data);
      } catch (error) {
        console.error("Blogları getirme hatası:", error);
      }
    };
    fetchBlogs();
  }, []);

  const indexOfLastBlog = currentPage * blogsPerPage;
  const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
  const currentBlogs = blogs.slice(indexOfFirstBlog, indexOfLastBlog);
  const totalPages = Math.ceil(blogs.length / blogsPerPage);

  return (
    <>
     <Helmet>
  {/* SEO Başlık */}
  <title>Hukuk Blogu | Avukatlık Makaleleri ve Bilgilendirici Yazılar</title>

  {/* SEO Açıklaması */}
  <meta
    name="description"
    content="Türk hukuku hakkında en güncel makaleler, dava süreçleri ve hukuki bilgilendirmeler için blog sayfamızı ziyaret edin."
  />

  {/* Robots Meta Tag */}
  <meta name="robots" content="index, follow" />

  {/* Canonical URL */}
  <link rel="canonical" href="https://aliardagul.av.tr/blog" />

  {/* Open Graph Etiketleri */}
  <meta property="og:title" content="Hukuk Blogu | Avukatlık Makaleleri ve Bilgilendirici Yazılar" />
  <meta
    property="og:description"
    content="Türk hukuku hakkında en güncel makaleler, dava süreçleri ve hukuki bilgilendirmeler için blog sayfamızı ziyaret edin."
  />
  <meta property="og:image" content="https://aliardagul.av.tr/assets/logo.webp" />
  <meta property="og:url" content="https://aliardagul.av.tr/blog" />
  <meta property="og:type" content="website" />

  {/* Twitter Card Etiketleri */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="Hukuk Blogu | Avukatlık Makaleleri ve Bilgilendirici Yazılar" />
  <meta
    name="twitter:description"
    content="Türk hukuku hakkında en güncel makaleler, dava süreçleri ve hukuki bilgilendirmeler için blog sayfamızı ziyaret edin."
  />
  <meta name="twitter:image" content="https://aliardagul.av.tr/assets/logo.webp" />
</Helmet>


      <div className="container mt-5">
        <header className="text-center mb-5">
          <h1 className="display-4 fw-bold">Hukuk Blogu</h1>
          <p className="lead text-muted">
            Hukuki süreçler, dava rehberleri ve güncel hukuk haberlerini keşfedin.
          </p>
        </header>

        <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-4">
          {currentBlogs.map((blog) => (
            <div className="col" key={blog.id}>
              <div className="card h-100 shadow-sm border-0">
                <img
                  src={blog.img}
                  alt={blog.name}
                  className="card-img-top"
                  style={{ height: "220px", objectFit: "cover" }}
                />
                <div className="card-body d-flex flex-column justify-content-between">
                  <h5
                    className="card-title"
                    dangerouslySetInnerHTML={{ __html: blog.name }}
                  />
                  <p className="text-muted small mb-1">
                    {new Date(blog.publishedDate).toLocaleDateString("tr-TR", {
                      day: "2-digit",
                      month: "long",
                      year: "numeric",
                    })}
                  </p>
                  <p
                    className="card-text"
                    dangerouslySetInnerHTML={{ __html: blog.description }}
                  />
                  <Link
                    to={`/blog/${blog.id}`}
                    className="btn btn-outline-dark mt-3"
                  >
                    Devamını Oku
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Pagination */}
        <div className="d-flex justify-content-center my-4">
          <nav>
            <ul className="pagination">
              {Array.from({ length: totalPages }, (_, index) => (
                <li
                  key={index}
                  className={`page-item ${currentPage === index + 1 ? "active" : ""}`}
                >
                  <button
                    className="page-link"
                    onClick={() => setCurrentPage(index + 1)}
                  >
                    {index + 1}
                  </button>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </div>

    </>
  );
};

export default Blog;
